// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1-3XZ","cell":"ColumnAccessor_cell__2OxDl","firstCellAccent":"ColumnAccessor_firstCellAccent__jEQRI"};